import { ComponentStyleConfig } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { DISABLED_OPACITY } from './constants'
import { getFormComponentStyle } from './getFormComponentStyle'

export const Select: ComponentStyleConfig = {
  variants: {
    rw1: (props: Dict) => ({
      field: {
        ...getFormComponentStyle(props),
      },
      icon: {
        _disabled: {
          opacity: DISABLED_OPACITY,
        },
      },
    }),
  },
  defaultProps: {
    variant: 'rw1',
  },
}
